<template>
    <div :class="getClass" :rawSignalValue="rawValue">
        {{ formatted.signal }}
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const rawValue = computed(() => props.formatted.raw.signal);

const getClass = computed(() => {
    const { smacd_signal } = props.formatted;
    switch (smacd_signal) {
        case 'N/A':
            return 'text-unch';
        case 'G':
            return 'text-white bg-green-500 px-2 py-px text-xs text-center';
        case 'Y':
            return 'text-black bg-[#ffc107] px-2 py-px text-xs text-center';
        case 'R':
            return 'text-white bg-red-500 px-2 py-px text-xs text-center';
        case 'C':
            return 'text-white bg-teal-500 px-2 py-px text-xs text-center';
        default:
            return '';  // Default class if none of the conditions are met
    }
});
</script>
